import { useHeaderRightNav } from '@perpay-web/fintech/hooks/useHeaderRightNavContext';

export const withBlankHeader = (Component) => (props) => {
    useHeaderRightNav(null);

    return <Component {...props} />;
};
